import { render, staticRenderFns } from "./RemainingAssetReport.vue?vue&type=template&id=0721ccf8"
import script from "./RemainingAssetReport.vue?vue&type=script&lang=js"
export * from "./RemainingAssetReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports